(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pickles-play-teaser"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pickles-play-preview')) {
  customElements.define('pickles-play-preview', class extends HTMLElement {
    connectedCallback() {
      this.setupFrame = requestAnimationFrame(() => this.setup());
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.setupFrame);
      this.stop();
      this.abort?.abort();
      this.observer?.disconnect();
      this.frames = null;
      this.loading = null;
    }
    setup() {
      if (!this.isConnected) return;
      this.abort?.abort();
      this.observer?.disconnect();
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.poster = this.querySelector('[data-overview]');
      this.stage = this.querySelector('[data-stage]');
      this.toggle = this.querySelector('[data-preview-toggle]');
      this.next = this.querySelector('[data-next]');
      this.status = this.querySelector('[data-status]');
      try { this.scenes = JSON.parse(this.querySelector('[data-scenes]').textContent); }
      catch { return; }
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.hover = matchMedia('(hover: hover)');
      this.stop();
      this.querySelector('[data-controls]').hidden = false;
      this.addEventListener('pointerenter', (event) => {
        if (event.pointerType !== 'touch' && this.hover.matches && !this.motion.matches && !this.mode) this.start('hover');
      }, { signal });
      this.addEventListener('pointerleave', () => { if (this.mode === 'hover') this.stop(); }, { signal });
      this.toggle.addEventListener('click', () => this.mode ? this.stop() : this.start('button'), { signal });
      this.next.addEventListener('click', () => {
        if (this.mode && this.motion.matches && this.frames?.length) this.showNext(true);
      }, { signal });
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.mode) { event.preventDefault(); this.stop(); }
        // Native buttons already provide Enter/Space activation.
      }, { signal });
      this.addEventListener('focusout', (event) => { if (!this.contains(event.relatedTarget)) this.stop(); }, { signal });
      this.motion.addEventListener('change', () => this.stop(), { signal });
      this.hover.addEventListener('change', () => this.stop(), { signal });
      window.addEventListener('blur', () => this.stop(), { signal });
      window.addEventListener('pagehide', () => this.stop(), { signal });
      document.addEventListener('visibilitychange', () => { if (document.hidden) this.stop(); }, { signal });
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver((entries) => {
          if (!entries[0].isIntersecting) this.stop();
        });
        this.observer.observe(this);
      }
    }
    available() { return this.isConnected && !document.hidden && document.hasFocus(); }
    async start(mode) {
      if (this.mode || !this.available()) return;
      this.mode = mode;
      const run = ++this.run;
      this.status.textContent = '';
      this.status.removeAttribute('data-error');
      this.sync(true);
      // No scene URL is assigned to an image until intentional hover or activation.
      if (!this.loading) this.loading = Promise.all(this.scenes.map((scene) => this.load(scene, this.abort.signal)));
      const frames = (await this.loading).filter(Boolean);
      if (run !== this.run || !this.mode || !this.available()) return;
      this.frames = frames;
      if (!frames.length) {
        this.loading = null;
        this.stop();
        this.status.textContent = this.dataset.errorLabel;
        this.status.setAttribute('data-error', '');
        return;
      }
      this.index = -1;
      this.showNext(mode === 'button');
      this.sync(false);
      this.schedule(run);
    }
    load(scene, signal) {
      return new Promise((resolve) => {
        const image = new Image(scene.width, scene.height);
        image.className = 'pickles-teaser__image';
        image.alt = scene.alt;
        image.decoding = 'async';
        let finished = false;
        const finish = (result) => {
          if (finished) return;
          finished = true;
          clearTimeout(timeout);
          image.onload = image.onerror = null;
          signal.removeEventListener('abort', cancel);
          resolve(result);
        };
        const cancel = () => { finish(null); image.removeAttribute('src'); };
        const timeout = setTimeout(cancel, 15000);
        image.onerror = () => finish(null);
        image.onload = async () => {
          try { if (image.decode) await image.decode(); }
          catch { finish(null); return; }
          finish(signal.aborted || !image.naturalWidth ? null : image);
        };
        signal.addEventListener('abort', cancel, { once: true });
        if (signal.aborted) cancel();
        else image.src = scene.src;
      });
    }
    showNext(announce) {
      this.index = (this.index + 1) % this.frames.length;
      const image = this.frames[this.index];
      this.stage.replaceChildren(image);
      this.stage.hidden = false;
      this.poster.setAttribute('aria-hidden', 'true');
      if (announce) this.status.textContent = image.alt;
    }
    schedule(run) {
      clearTimeout(this.timer);
      if (this.motion.matches || !this.mode || this.frames.length < 2) return;
      this.timer = setTimeout(() => {
        this.timer = 0;
        if (run !== this.run || !this.mode || !this.available()) return;
        this.showNext(false);
        this.schedule(run);
      }, 700);
    }
    sync(loading = false) {
      if (!this.toggle) return;
      this.toggle.setAttribute('aria-pressed', String(Boolean(this.mode)));
      this.toggle.textContent = this.mode ? (loading ? this.dataset.loadingLabel : this.dataset.stopLabel) : this.dataset.previewLabel;
      this.next.hidden = !(this.mode && this.motion.matches);
      this.next.disabled = loading;
    }
    stop() {
      this.run = (this.run || 0) + 1;
      this.mode = null;
      clearTimeout(this.timer);
      this.timer = 0;
      if (this.stage) { this.stage.hidden = true; this.stage.replaceChildren(); }
      this.poster?.removeAttribute('aria-hidden');
      if (this.status) { this.status.textContent = ''; this.status.removeAttribute('data-error'); }
      this.sync();
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
